<template>
  <div class="home-news-list">
    <app-preview-list title="Новости рынка" linkText="все новости" link="/news">
      <div class="div" v-if="!isLoading">
        <template v-for="(item, idx) in lastNews">
          <router-link
            tag="div"
            :to="`news/item/${item.id}`"
            class="app-preview-list__item home-news-list__item"
            :key="idx"
          >
            <div class="home-news-list__tag-col">
              <app-hashtag>{{ item.categories[0].title }}</app-hashtag>
            </div>
            <div class="home-news-list__description-col">
              <p class="home-news-list__description">{{ item.header }}</p>
            </div>
            <div class="home-news-list__date-col">
              {{ item.publishedAt | dateFormat('dd.MM.yyyy HH:mm') }}
            </div>
          </router-link>
        </template>
      </div>
      <app-loader v-if="isLoading" isAbsolute isCircle></app-loader>
    </app-preview-list>
  </div>
</template>
<script>
import { newsMapper } from '@/store/news';

export default {
  name: 'HomeNewslist',
  components: {
    AppPreviewList: () => import('@/components/common/AppPreviewList'),
    AppHashtag: () => import('@/components/ui/AppHashtag'),
    AppLoader: () => import('@/components/ui/AppLoader'),
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...newsMapper.mapGetters(['lastNews']),
  },
  created() {
    this.asyncData();
  },
  methods: {
    ...newsMapper.mapActions(['getNews']),
    /**
     * стартовые данные
     */
    async asyncData() {
      this.isLoading = true;

      const data = {
        pagination: { offset: 0, limit: 5 },
      };
      try {
        await this.getNews(data);
      } catch {
        //
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="scss">
.home-news-list {
  position: relative;

  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 220px;
  }

  &__item {
    display: flex;
    align-items: center;
    min-height: 44px;
    padding: 9px 0;
    cursor: pointer;

    @include media-xs() {
      flex-direction: column;
      align-items: stretch;
    }
  }

  &__tag-col {
    flex-basis: 90px;
    flex-shrink: 0;

    @include media-xs() {
      flex-basis: auto;
      align-self: flex-start;
    }
  }

  &__description-col {
    flex-grow: 1;
    min-width: 0;
    padding: 0 10px;

    @include media-xs() {
      padding: 13px 0;
    }
  }

  &__description {
    margin: 0;
    overflow: hidden;
    font-size: rem(12);
    line-height: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__date-col {
    flex-basis: 90px;
    flex-shrink: 0;
    font-size: rem(10);
    font-weight: 300;
    line-height: 13px;
    color: $gray-dark;
    letter-spacing: 0.03em;

    @include media-xs() {
      flex-basis: auto;
      align-self: flex-end;
    }
  }
}
</style>
